module.exports = __webpack_public_path__ + "static/1_RhinoLogo-d1b0fc865b9f2b7b9392de5699a76b22.png";